export function milliFormat(num: number | string): string {
  if (!num) return num.toString();
  return num.toString().replace(/\d+/, function (s) {
    return s.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
  });
}

export function formatNum(num: number, fixed = 2): string {
  return num ? num.toFixed(fixed) : "0.00";
}
export const formatMoney = (
  amount: number | string,
  type: 0 | 1 | 2 = 0
): string => {
  try {
    // 处理空值或无效值
    if (amount === "" || amount === null || amount === undefined) {
      return type === 2 ? "0" : "￥0";
    }

    // 转字符串并去除前后空格
    let amountStr = String(amount).trim();

    // 处理科学计数法
    if (amountStr.includes("e")) {
      amountStr = Number(amountStr).toString();
    }

    // 处理数字格式
    const parts = amountStr.split(".");
    const integerPart = parts[0];
    let decimalPart = parts[1] || "";

    // 如果小数部分存在，处理精度
    if (decimalPart) {
      // 限制最多6位小数
      decimalPart = decimalPart.slice(0, 6);
      // 去除尾部多余的0
      decimalPart = decimalPart.replace(/0+$/, "");

      // 如果小数部分全为0或为空，返回整数
      if (!decimalPart) {
        if (type === 2) return integerPart;
        return type === 1 ? `￥${integerPart}/1次` : `￥${integerPart}`;
      }

      // 组合结果
      const result = `${integerPart}.${decimalPart}`;
      if (type === 2) return result;
      return type === 1 ? `￥${result}/1次` : `￥${result}`;
    }

    // 没有小数部分直接返回
    if (type === 2) return integerPart;
    return type === 1 ? `￥${integerPart}/1次` : `￥${integerPart}`;
  } catch {
    return type === 2 ? "0" : "￥0";
  }
};
/**
 * 字节转换KB、MB、GB等
 * @param bytes number 要转换的字节数
 * @param decimals number 结果的小数位数
 * @returns string
 */

export function formatBytes(bytes: number, decimals = 2) {
  if (bytes === 0) return "0 KB";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + "" + sizes[i];
}
